import React, { Dispatch, SetStateAction } from 'react';
import {
  FlexStyle, Pressable, ScrollView, StyleSheet, Text,
} from 'react-native';
import { Region } from '../../../Map/SetFloorsModal/FloorItem';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';

interface RegionDropdownProps {
  regions: Region[],
  selectedRegion: Region,
  setSelectedRegion: Dispatch<SetStateAction<Region>>,
  testID?: string,
  style?: FlexStyle,
}

const RegionDropdown = ({
  regions, selectedRegion, setSelectedRegion, testID, style,
}: RegionDropdownProps) => <ScrollView
  nestedScrollEnabled
  indicatorStyle={'black'}
  style={[styles.dropdownView, style]}
  {...{ testID }}
>
    {regions.map((region: Region) => {
      const selected: boolean = region.LocationId === selectedRegion?.LocationId;
      return <Pressable
        onPress={() => setSelectedRegion(region)}
        style={(state: { hovered: boolean, pressed: boolean }) => [
          state.hovered && Style.listItemHovered, state.pressed && Style.listItemPressed,
          selected && styles.itemSelected,
        ]}
        key={`floor_option_${region.LocationId}`}
        testID={`${testID}-option-${region.LocationId}`}
      >
        <Text style={[styles.dropdownItemText, selected && styles.textSelected]}>
          {region?.Name}
        </Text>
      </Pressable>;
    })}
  </ScrollView>;

const styles = StyleSheet.create({
  dropdownView: {
    zIndex: 5,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksPaleBlue900,
    backgroundColor: '#fff',
    marginTop: 4,
    maxHeight: 180,
    alignSelf: 'stretch',
  },
  dropdownItemText: {
    marginLeft: 12,
    marginVertical: 9,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksPrimaryGrey,
  },
  textSelected: {
    color: '#FFF',
  },
  itemSelected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
  },
});

export default RegionDropdown;
